import { render, staticRenderFns } from "./AddReceive.vue?vue&type=template&id=53191bd2"
import script from "./AddReceive.vue?vue&type=script&lang=js"
export * from "./AddReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports